import { Card, CardContent } from "ui/components/card";
import classNames from "classnames";
import { assetUrl } from "utils";

export function EvtQuickLinksCard({
    onClick,
    disabled,
    className,
    label,
    description,
    favicon,
}) {
    return (
        <Card
            onClick={disabled ? undefined : onClick}
            className={classNames("h-max shadow-none py-3", className)}
        >
            <CardContent>
                <div className="flex flex-col md:flex-row items-start md:items-center gap-4 relative">
                    {/* Favicon */}
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center">
                        <img
                            src={assetUrl(favicon)}
                            alt={`${label} favicon`}
                            className="w-10 h-10 object-contain rounded-md"
                        />
                    </div>

                    <div className="space-y-0.5">
                        <h3 className="text-base font-semibold leading-6 text-card-foreground">
                            {label}
                        </h3>
                        <p className="text-sm font-normal leading-5 text-muted-foreground line-clamp-1">
                            {description}
                        </p>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}
